import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  makeStyles,
  Paper,
  Grid,
  FormControl,
  OutlinedInput,
  InputAdornment,
  InputBase,
  Select,
  withStyles,
  MenuItem,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import { Pagination, PaginationItem } from "@material-ui/lab";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import { Select as AntSelect } from "antd";

import {
  getAdminSupportActivitiesTable,
  createUpdateAdminSupportActivity,
  clearAdminSupport,
  downloadAdminSupportActivity,
} from "../../../actions/project-management-actions";
import {
  getActivityMasterSettings,
  getSubjectMasterSettings,
  getAdminDepartments,
} from "../../../actions/admin-actions";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import { UploadIcon, DownloadIcon } from "../../../shared-resources/SVGIcons";
import {
  downloadFile,
  getPaginationPageNumber,
  getResponse,
} from "../../../shared-resources/utils";
import { created_by } from "../../../shared-resources/dumpData";

const { Option } = AntSelect;

const useStyles = makeStyles((theme) => ({
  componentStyles: {},
  tablePaper: {
    borderRadius: "12px",
    padding: "12px",
  },
  searchSection: {
    marginBottom: "4px",
  },
  searchTextField: {
    borderRadius: "25px",
    fontSize: "14px",
    height: "36px",
  },
  searchIcon: {
    color: "#ccc",
  },
  addBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "1px solid #3599d1",
    color: "#ffff",
    backgroundColor: "#0176d3",
    borderRadius: "25px",
    margin: "2px 0 2px 80px",
  },
  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  updateBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    color: "#ffff",
    backgroundColor: "#0176d3",
    borderRadius: "25px",
    marginRight: "8px",
  },
  checkCircleIcon: {
    fontSize: "18px",
    color: "#075e07",
    cursor: "pointer",
    marginTop: "2px",
  },
  checkCircleIconSpan: {
    cursor: "pointer",
    marginLeft: "2px",
  },
  paginationSection: {
    marginTop: "4px",
  },
  searchSection: {
    marginBottom: "4px",
  },
  editIcon: {
    fontSize: "16px",
    color: "#0070D2",
    cursor: "pointer",
  },
  editTextField: {
    height: "24px",
    fontSize: "12px",
    width: "180px",
    padding: "2px",
    background: "#fff",
  },
  editText: {
    padding: "0",
  },

  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    fontSize: "13px",
  },

  addDialog: {
    width: "350px",
    height: "auto",
    position: "relative",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  required: {
    color: "red",
  },
  saveBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "none",
    color: "#ffff",
    backgroundColor: "#0176d3",
    marginRight: "8px",
  },

  departmentDropdown: {
    marginTop: "2px",
    width: "205px",
  },
  statusDropdown: {
    marginTop: "2px",
    width: "100px",
  },
  departmentDropdownPopup: {
    width: "100%",
  },
}));

export default function AdminSupportMain() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isEnabled, setIsEnabled] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isAdded, setIsAdded] = useState(false);
  const [isValueUpdated, setIsValueUpdated] = useState(false);
  const [openDialogAdd, setOpenDialogAdd] = useState(false);
  const [isDownloadClick, setIsDownloadClick] = useState(false);
  const [subjectsListData, setSubjectsListData] = useState([]);
  const [activitiesListData, setActivitiesListData] = useState([]);
  const [departmentsListData, setDepartmentsListData] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState();
  const [selectedActivity, setSelectedActivity] = useState();

  const adminSupportActivityData = useSelector(
    (state) => state.projectManagementReducer.adminSupportActivityData
  );

  const updateAdminSupportActivityData = useSelector(
    (state) => state.projectManagementReducer.updateAdminSupportActivityData
  );

  const downloadAdminSupportActivityData = useSelector(
    (state) => state.projectManagementReducer.downloadAdminSupportActivityData
  );

  const activitiesData = useSelector(
    (state) => state.adminReducer.activitiesData
  );

  const subjectsData = useSelector((state) => state.adminReducer.subjectsData);

  const departmentsData = useSelector(
    (state) => state.adminReducer.adminDepartmentsData
  );

  const clearData = () => {
    dispatch(clearAdminSupport());
  };

  useEffect(() => {
    return () => clearData();
  }, []);

  useEffect(() => {
    dispatch(getAdminSupportActivitiesTable());
    dispatch(getActivityMasterSettings());
    dispatch(getSubjectMasterSettings());
    dispatch(getAdminDepartments());
    setLoading(true);
  }, []);

  useEffect(() => {
    if (downloadAdminSupportActivityData.type && isDownloadClick) {
      setLoading(false);
      downloadFile(downloadAdminSupportActivityData, "adminSupport");
      setIsDownloadClick(false);
    }
  }, [downloadAdminSupportActivityData]);

  useEffect(() => {
    if (subjectsData.status && subjectsData.status === 200) {
      const data = JSON.parse(
        JSON.stringify(getResponse(subjectsData, []))
      ).filter((item) => item.status.toLowerCase() === "active");
      data.forEach((val) => {
        val.value = val.subjectId;
        val.label = val.subject;
      });
      setSubjectsListData(data);
    }
  }, [subjectsData]);

  useEffect(() => {
    if (activitiesData.status && activitiesData.status === 200) {
      const data = JSON.parse(
        JSON.stringify(getResponse(activitiesData, []))
      ).filter((item) => item.status.toLowerCase() === "active");
      data.forEach((val) => {
        val.value = val.activityId;
        val.label = val.activity;
      });
      setActivitiesListData(data);
    }
  }, [activitiesData]);

  useEffect(() => {
    if (departmentsData.status && departmentsData.status === 200) {
      const data = JSON.parse(JSON.stringify(getResponse(departmentsData, [])));
      data.forEach((val) => {
        val.value = val.department_id;
        val.label = val.department;
      });
      setDepartmentsListData(data);
    }
  }, [departmentsData]);

  useEffect(() => {
    if (
      adminSupportActivityData.status &&
      (adminSupportActivityData.status === 200 ||
        adminSupportActivityData.status === 400)
    ) {
      setLoading(false);
    }
    if (
      adminSupportActivityData.status &&
      adminSupportActivityData.status === 200
    ) {
      const data = getResponse(adminSupportActivityData, []);
      data.forEach((val, i) => {
        val.isEdit = false;
        val.tempId = i + 1;
      });
      setTableData(data);
    }
  }, [adminSupportActivityData]);

  useEffect(() => {
    if (
      isValueUpdated &&
      updateAdminSupportActivityData.status &&
      updateAdminSupportActivityData.status === 200
    ) {
      setLoading(false);
      setIsValueUpdated(false);
      setIsEnabled(false);
      setMsgType("Success");
      setEmptyErrMsg(true);
      if (isAdded) {
        setMsgText(`Admin support added successfully`);
        setIsAdded(false);
      } else setMsgText(`Admin support updated successfully`);
      dispatch(getAdminSupportActivitiesTable());
    }
    if (
      isValueUpdated &&
      updateAdminSupportActivityData.status &&
      updateAdminSupportActivityData.status === 400
    ) {
      setLoading(false);
      setIsValueUpdated(false);
      setMsgType("Error");
      setEmptyErrMsg(true);
      setMsgText(updateAdminSupportActivityData.message);
    }
  }, [isValueUpdated, updateAdminSupportActivityData]);

  const compareDepartment = (a, b) => {
    if (
      a.department.toString().toLowerCase() <
      b.department.toString().toLowerCase()
    ) {
      return -1;
    }
    if (
      a.department.toString().toLowerCase() >
      b.department.toString().toLowerCase()
    ) {
      return 1;
    }
    return 0;
  };

  const sortDepartments = (data) => {
    if (data && data.length > 0) {
      const sortData = JSON.parse(JSON.stringify(data));
      sortData.sort(compareDepartment);
      return sortData;
    }
    return [];
  };

  const compareSubject = (a, b) => {
    if (
      a.subject.toString().toLowerCase() < b.subject.toString().toLowerCase()
    ) {
      return -1;
    }
    if (
      a.subject.toString().toLowerCase() > b.subject.toString().toLowerCase()
    ) {
      return 1;
    }
    return 0;
  };

  const sortSubjects = (data) => {
    if (data && data.length > 0) {
      const sortData = JSON.parse(JSON.stringify(data));
      sortData.sort(compareSubject);
      return sortData;
    }
    return [];
  };

  const compareActivity = (a, b) => {
    if (
      a.activity.toString().toLowerCase() < b.activity.toString().toLowerCase()
    ) {
      return -1;
    }
    if (
      a.activity.toString().toLowerCase() > b.activity.toString().toLowerCase()
    ) {
      return 1;
    }
    return 0;
  };

  const sortActivities = (data) => {
    if (data && data.length > 0) {
      const sortData = JSON.parse(JSON.stringify(data));
      sortData.sort(compareActivity);
      return sortData;
    }
    return [];
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const onAddClick = () => {
    setSelectedActivity();
    setSelectedSubject();
    setSelectedDepartment([]);
    setOpenDialogAdd(true);
  };

  const downloadAdminSupport = () => {
    setIsDownloadClick(true);
    dispatch(downloadAdminSupportActivity());
    setLoading(true);
  };

  const cancelUpdate = () => {
    const data = getResponse(adminSupportActivityData, []);
    data.forEach((val, i) => {
      val.isEdit = false;
      val.tempId = i + 1;
    });
    setTableData(data);
    setIsEnabled(false);
  };

  const updateData = () => {
    setLoading(true);
    setIsValueUpdated(true);
    dispatch(createUpdateAdminSupportActivity(tableData));
  };

  const changeEditStatus = (id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) val.isEdit = !val.isEdit;
    });
    setTableData(changedData);
  };

  const onStatusChange = (value, id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) val.status = value;
    });
    setTableData(changedData);
    setIsEnabled(true);
  };

  const onChangeSubject = (value, id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) {
        val.subjectId = value;
        val.subject = subjectsListData.filter(
          (item) => item.subjectId === value
        )[0].subject;
      }
    });
    setTableData(changedData);
    setIsEnabled(true);
  };

  const onChangeActivity = (value, id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) {
        val.activityId = value;
        val.activity = activitiesListData.filter(
          (item) => item.activityId === value
        )[0].activity;
      }
    });
    setTableData(changedData);
    setIsEnabled(true);
  };

  const onChangeDepartment = (value, id) => {
    if (value.length > 0) {
      const changedData = JSON.parse(JSON.stringify(tableData));
      changedData.forEach((val) => {
        if (val.tempId === id) {
          val.departmentId = value.join(",");
          let depName = "";
          departmentsListData.forEach((item) => {
            if (value.indexOf(item.department_id) >= 0)
              depName += item.department + ",";
          });
          if (depName !== "")
            depName = depName.substring(0, depName.length - 1);
          val.department = depName;
        }
      });
      setTableData(changedData);
      setIsEnabled(true);
    }
  };

  const filterData = () => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    if (searchText.trim() !== "") {
      return changedData.filter(
        (val) =>
          val.activity
            .toString()
            .trim()
            .toLowerCase()
            .includes(searchText.toString().trim().toLowerCase()) ||
          val.subject
            .toString()
            .trim()
            .toLowerCase()
            .includes(searchText.toString().trim().toLowerCase()) ||
          val.status
            .toString()
            .trim()
            .toLowerCase()
            .includes(searchText.toString().trim().toLowerCase()) ||
          val.department
            .toString()
            .trim()
            .toLowerCase()
            .includes(searchText.toString().trim().toLowerCase())
      );
    }
    return changedData;
  };

  const handleCloseDialogAdd = () => {
    setOpenDialogAdd(false);
  };

  const onAddActivityClick = () => {
    const subjectName = subjectsListData.filter(
      (item) => item.subjectId === selectedSubject
    )[0].subject;
    const activityName = activitiesListData.filter(
      (item) => item.activityId === selectedActivity
    )[0].activity;
    if (
      tableData.filter(
        (val) =>
          val.subjectId === selectedSubject &&
          val.activityId === selectedActivity
      ).length > 0
    ) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(
        `Combination already exists for subject: ${subjectName} and activity: ${activityName}`
      );
      setLoading(false);
      return false;
    }
    let depName = "";
    departmentsListData.forEach((item) => {
      if (selectedDepartment.indexOf(item.department_id) >= 0)
        depName += item.department + ",";
    });
    if (depName !== "") depName = depName.substring(0, depName.length - 1);
    const maxIndex = Math.max(...tableData.map((o) => o.tempId));
    setTableData([
      {
        activity: activityName,
        activityId: selectedActivity,
        subject: subjectName,
        subjectId: selectedSubject,
        department: depName,
        departmentId: selectedDepartment.join(","),
        created_by: created_by,
        created_date: new Date(),
        status: "Active",
        tempId: maxIndex + 1,
      },
      ...tableData,
    ]);
    setIsEnabled(true);
    setOpenDialogAdd(false);
  };

  const onCancelClick = () => {
    setOpenDialogAdd(false);
  };

  return (
    <Paper elevation={0} className={classes.tablePaper}>
      <Grid container className={classes.searchSection} spacing={0}>
        <Grid item lg={6}>
          <FormControl variant="outlined" className={classes.searchControl}>
            <OutlinedInput
              className={classes.searchTextField}
              type="text"
              placeholder="Search"
              onChange={(e) => onSearchChange(e)}
              value={searchText}
              endAdornment={
                <InputAdornment position="start">
                  <SearchIcon className={classes.searchIcon} />
                </InputAdornment>
              }
            />
          </FormControl>
          <Button
            className={classes.addBtn}
            variant="contained"
            color="primary"
            onClick={onAddClick}
          >
            Add
          </Button>
        </Grid>
        <Grid item lg={6} style={{ position: "relative" }}>
          <Button
            variant="outlined"
            className={classes.cancelBtn}
            color="primary"
            onClick={() => cancelUpdate()}
            disabled={!isEnabled}
            style={{ marginTop: "4px", float: "right" }}
          >
            Cancel
          </Button>
          <Button
            className={classes.updateBtn}
            variant="contained"
            color="primary"
            onClick={updateData}
            disabled={!isEnabled}
            style={{ marginTop: "4px", float: "right" }}
          >
            Update
          </Button>
          <span
            style={{
              cursor: "pointer",
              marginRight: "6px",
              float: "right",
              marginTop: "-3px",
            }}
            title="Download Admin Support"
            onClick={() => downloadAdminSupport()}
          >
            <DownloadIcon background="#0070D2" color="#fff" />
          </span>
        </Grid>
      </Grid>
      {filterData(tableData).length > 0 ? (
        <table className="generalSettingsTable">
          <thead>
            <tr>
              <td>Subject</td>
              <td>Activity</td>
              <td>Departments</td>
              <td>Status</td>
            </tr>
          </thead>
          <tbody>
            {filterData(tableData)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((tableItem, i) => (
                <tr key={i}>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <span style={{ float: "left" }}>
                      {tableItem.isEdit ? (
                        <AntSelect
                          mode="single"
                          showArrow
                          filterOption={(input, option) =>
                            (
                              option?.label.toString().toLowerCase() ?? ""
                            ).includes(input.toString().toLowerCase())
                          }
                          className={classes.departmentDropdown}
                          value={tableItem.subjectId}
                          onChange={(value) =>
                            onChangeSubject(value, tableItem.tempId)
                          }
                          options={sortSubjects(subjectsListData)}
                        />
                      ) : (
                        tableItem.subject
                      )}
                    </span>

                    {tableItem.isEdit ? (
                      <span className={classes.checkCircleIconSpan}>
                        <CheckCircleIcon
                          className={classes.checkCircleIcon}
                          onClick={() => changeEditStatus(tableItem.tempId)}
                        />
                      </span>
                    ) : (
                      <span className="settinsTableEdit">
                        <EditIcon
                          className={classes.editIcon}
                          onClick={() => changeEditStatus(tableItem.tempId)}
                        />
                      </span>
                    )}
                  </td>
                  <td>
                    <span style={{ float: "left" }}>
                      {tableItem.isEdit ? (
                        <AntSelect
                          showArrow
                          filterOption={(input, option) =>
                            (
                              option?.label.toString().toLowerCase() ?? ""
                            ).includes(input.toString().toLowerCase())
                          }
                          mode="single"
                          className={classes.departmentDropdown}
                          value={tableItem.activityId}
                          onChange={(value) =>
                            onChangeActivity(value, tableItem.tempId)
                          }
                          options={sortActivities(activitiesListData)}
                        />
                      ) : (
                        tableItem.activity
                      )}
                    </span>
                  </td>
                  <td>
                    <span style={{ float: "left" }}>
                      {tableItem.isEdit ? (
                        <AntSelect
                          mode="multiple"
                          className={classes.departmentDropdown}
                          value={
                            tableItem.departmentId !== ""
                              ? tableItem.departmentId
                                  .split(",")
                                  .map((val) => parseInt(val))
                              : []
                          }
                          onChange={(value) =>
                            onChangeDepartment(value, tableItem.tempId)
                          }
                          filterOption={(input, option) =>
                            (
                              option?.label?.toString().toLowerCase() ?? ""
                            ).includes(input.toString().toLowerCase())
                          }
                          options={sortDepartments(departmentsListData)}
                        />
                      ) : (
                        tableItem.department
                      )}
                    </span>
                  </td>
                  <td>
                    {tableItem.isEdit ? (
                      <AntSelect
                        mode="single"
                        className={classes.statusDropdown}
                        value={tableItem.status}
                        onChange={(value) =>
                          onStatusChange(value, tableItem.tempId)
                        }
                      >
                        <Option key="Active" value="Active">
                          Active
                        </Option>
                        <Option key="Inactive" value="Inactive">
                          Inactive
                        </Option>
                      </AntSelect>
                    ) : (
                      tableItem.status
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <div
          style={{ textAlign: "center", padding: "20px 0", fontWeight: 600 }}
        >
          No results found
        </div>
      )}
      {filterData(tableData).length > 0 && (
        <Grid container className={classes.paginationSection} spacing={0}>
          <Grid item lg={12}>
            <div style={{ float: "right", marginTop: "6px" }}>
              <Pagination
                count={Math.ceil(filterData(tableData).length / rowsPerPage)}
                showFirstButton
                showLastButton
                page={page + 1}
                onChange={handleChangePage}
                color="primary"
                style={{ float: "right" }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    page={getPaginationPageNumber(
                      item.page - 1,
                      filterData(tableData).length,
                      rowsPerPage
                    )}
                  />
                )}
              />
            </div>
            <div style={{ float: "right", marginTop: "6px" }}>
              <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
              <FormControl className="tableRowsDdl">
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  input={<BootstrapInput />}
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      )}
      <Dialog
        open={openDialogAdd}
        onClose={handleCloseDialogAdd}
        aria-labelledby="max-width-dialog-title"
        // disableBackdropClick
      >
        <DialogContent className={classes.addDialog}>
          <div className={classes.popupHeader}>
            <span
              className={classes.closeIconAdd}
              onClick={() => setOpenDialogAdd(false)}
            >
              x
            </span>
            <div className={classes.addColumnTitle}>Add</div>
          </div>
          <Grid container spacing={2}>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Subject<span className={classes.required}>*</span>
              </div>
              <AntSelect
                mode="single"
                placeholder="Select Subject"
                style={{ width: "100%" }}
                value={selectedSubject}
                onChange={(value) => setSelectedSubject(value)}
                filterOption={(input, option) =>
                  (option?.label?.toString().toLowerCase() ?? "").includes(
                    input.toString().toLowerCase()
                  )
                }
                options={sortSubjects(subjectsListData)}
              />
            </Grid>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Activity<span className={classes.required}>*</span>
              </div>
              <AntSelect
                mode="single"
                style={{ width: "100%" }}
                placeholder="Select Activity"
                value={selectedActivity}
                onChange={(value) => setSelectedActivity(value)}
                options={sortActivities(activitiesListData)}
                filterOption={(input, option) =>
                  (option?.label?.toString().toLowerCase() ?? "").includes(
                    input.toString().toLowerCase()
                  )
                }
              />
            </Grid>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Department(s)<span className={classes.required}>*</span>
              </div>
              <AntSelect
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Select Department(s)"
                value={selectedDepartment}
                onChange={(value) => setSelectedDepartment(value)}
                filterOption={(input, option) =>
                  (option?.label?.toString().toLowerCase() ?? "").includes(
                    input.toString().toLowerCase()
                  )
                }
                options={sortDepartments(departmentsListData)}
              />
            </Grid>
          </Grid>
          <div className={classes.popupBtnsAdd}>
            <Button
              className={classes.saveBtn}
              variant="contained"
              color="primary"
              onClick={onAddActivityClick}
              disabled={
                !selectedActivity ||
                !selectedSubject ||
                selectedDepartment.length === 0
              }
            >
              Add
            </Button>
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              color="primary"
              onClick={onCancelClick}
            >
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </Paper>
  );
}
